import { getSelectioAxios } from '@/main';

export default class AnalysisService {

  getAllPeriods() {
    return getSelectioAxios().get('/analyses/periods')
      .then(response => response.data);
  }

  countAnalysedBuyersByPortfolioAndPeriod(idPortfolio, idPeriod) {
    const variables = {
      'portfolioId': idPortfolio,
      'periodId': idPeriod,
    };
    return getSelectioAxios()
      .post('/analyses/buyers/count', variables)
      .then(response => response.data);
  }

  getVerifiedExposureByPortfolioAndPeriod(idPortfolio, idPeriod) {
    return getSelectioAxios()
      .get('/analyses/portfolios/' + idPortfolio + '/periods/' + idPeriod + '/verified-exposure')
      .then(response => {
        return response.data;
      });
  }

}
